import { useAppState } from "../contexts/AppContext";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useRedirectHomeIfOnRestrictedPage = () => {
    const [appState, setAppState] = useAppState();
    const location = useLocation();

    useEffect(() => {
        if (!appState.authorized && !appState.user) {
            window.location.href = `${window.location.origin}/`;
        }
    }, [appState, setAppState, location]);
}

export default useRedirectHomeIfOnRestrictedPage;
